<template>
	<div class="push__bottom">
    <div class="wysiwyg push__bottom--double">
			<h2 class="soft__bottom">{{title}}</h2>
			<ul>	
				<li v-bind:key="item" v-for="item in items">
					<span v-if="item">
						{{item}}
					</span>
				</li>
			</ul>
		</div>
</div>
</template>

<script>
export default {
	name: 'Rationale',
	props: {
		title: String,
		variant: {
			type: String,
			default: "list-success"
		},
    items: [String]
	}
}
</script>